import LookupCategoriesRequestModel from '../../../generated/types/model/request/LookupCategoriesRequestModel';

export default class LookupCategoriesRequestViewModel extends LookupCategoriesRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
